<template>
  <div>
    <div class="searchDiv">
      <el-input class="searchInput" v-model="params.orderNo" placeholder="请输入订单号" clearable
                @clear="getPageList"
                @keyup.enter.native="getPageList"/>
      <el-button type="primary" @click="getPageList">查询</el-button>
    </div>
    <el-table :data="tableData" row-key="id" border>
      <el-table-column label="客户姓名" prop="order.customerName" width="150px"></el-table-column>
      <el-table-column label="订单号" prop="orderNo" width="250px"></el-table-column>
      <el-table-column label="产品" prop="order.productName"></el-table-column>
      <el-table-column label="业务员" prop="order.salesmanName"></el-table-column>
      <el-table-column label="审批流程" prop="flowName"></el-table-column>
      <el-table-column label="审批步骤" prop="flowStep.name"></el-table-column>
      <el-table-column label="审批岗位" prop="flowStep.approvalPosName"></el-table-column>
      <el-table-column label="创建时间" prop="createTime"></el-table-column>
      <el-table-column label="操作" prop="option" width="220px" align="center">
        <template slot-scope="scope">
          <el-button v-if="hasPer('auditor:approval')" type="primary" @click="approval(scope.row)">
            审批
          </el-button>
          <el-button v-if="hasPer('auditor:refund')" type="warning" @click="backTask(scope.row)">
            退领
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <pagination :current.sync="current" :size.sync="size" :total="total" @get-list="getPageList"></pagination>
    <order-audit-info v-if="false" :dialog-visible="orderDialogVisible" @update:dialogVisible="updateOrderDialogVisible"
                      :order-no="approvalObj.orderNo"></order-audit-info>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import store from "@/store";
import {backTask, gainPage} from "@/api/sys/flow/audit";
import OrderAuditInfo from "@/views/approval/task/orderAuditInfo.vue";
import routers from "@/router/routers";

export default {
  name: "auditMine",
  components: {
    OrderAuditInfo,
    Pagination
  },
  data() {
    return {
      params: {
        orderNo: ''
      },
      isLoading: false,
      tableData: [],
      orderDialogVisible: false,
      approvalObj: {},
      rollbackSteps: [],
      current: 1,
      size: 10,
      total: 0
    }
  },
  mounted() {
    this.getPageList();
  },
  methods: {
    hasPer,
    getPageList() {
      gainPage({...this.params}).then(res => {
        this.tableData = res.records
        this.total = res.total
      })
    },
    approval(row) {
      //  将当前打开的菜单添加到已打开列表中
      store.dispatch('addTabAction', {name: "订单审批", path: `/order/approval`, params: {orderNo: row.orderNo}})
      //  将激活菜单改成选中的菜单
      store.dispatch('activeIndexAction', "订单审批")
      routers.push({name: "订单审批", params: {orderNo: row.orderNo, isApproval: true}})
    },
    backTask(row) {
      this.$confirm('确定退还认领的订单【' + row.orderNo + '】的审批？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        backTask({taskId: row.id}).then(() => {
          successMsg("操作成功")
          this.getPageList()
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    },
    updateOrderDialogVisible(val) {
      this.orderDialogVisible = val
    }
  }
}
</script>

<style scoped>

</style>
